<template>
  <div style="padding: 10px">
    <div v-if="componentParam !== 'mes_mold_processing_scheduling_print'">
      <el-form :model="formData" :disabled="disabled" label-width="150px">
        <el-row justify="space-between" style="text-align: center;margin-top: 10px">
          <el-col :span="12">
            <el-form-item label="模具编号：" required>
              <el-select v-model="formData.mold_id" @change="moldIdChange(formData.mold_id)" filterable clearable
                         @clear="moldIdChange(formData.mold_id)" >
                <el-option v-for="item in this.moldIdList" :value="item.value" :key="item.value"
                           :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="零件编号：" required>
              <el-select v-model="formData.part_no" @change="getPartInfo" filterable clearable @clear="getPartInfo">
                <el-option v-for="item in this.partNoList" :value="item.part_no" :key="item.part_no"
                           :label="item.part_no"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成本类型：" required>
              <el-select v-model="formData.cost_type" @change="createQrCode" filterable clearable @clear="createQrCode">
                <el-option v-for="item in this.costTypeList" :value="item.value" :key="item.value"
                           :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="零件名称：">
              <el-input v-model="formData.part_name" disabled></el-input>
            </el-form-item>
            <el-form-item label="数量：">
              <el-input v-model="formData.number" disabled></el-input>
            </el-form-item>
            <el-form-item label="材质：">
              <el-input v-model="formData.material" disabled></el-input>
            </el-form-item>
            <el-form-item label="规格：">
              <el-input v-model="formData.specifications" disabled></el-input>
            </el-form-item>
            <el-form-item label="热处理硬度：">
              <el-input v-model="formData.heat_treatment_hardness" disabled ></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="formData.remark" disabled autosize type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="零件二维码：">
            </el-form-item>
            <el-image style="width: 40%;height: 80%" :src="url" >
              <template #error>
                <div class="image-slot">
                  {{ "选择模具、零件、成本类型后显示" }}
                </div>
              </template>
            </el-image>
          </el-col>
        </el-row>
        <el-row style="font-weight:bold;margin-bottom: 20px;margin-left: 13px;"><b>加工图纸：</b></el-row>
        <el-row style="margin-left: 5ch"
                v-if="componentParam === 'mes_mold_processing_scheduling_add' || componentParam === 'mes_mold_processing_scheduling_update'">
          <kf-file-upload v-model="formData.attachments" :init-file="fileList"
                          @fileChange="fileChange"
                          :limit="10" :showTotalCnt="true" :showSuccessCnt="true"></kf-file-upload>
        </el-row>
      </el-form>
      <el-row style="font-weight:bold;margin-left: 12px;"
              v-if="this.fileList.length > 0 && ( componentParam === 'mes_mold_processing_scheduling_details' || componentParam === 'mes_mold_mm_process_detail')">
        <el-col :span="22" v-for="item in this.fileList" :key="item.id"
                style="width: 100%;height: 100%;margin-left: 40px">
          <el-button text @click="startPage(item,this.fileList)" class="startPageClass">{{item.original_name}}</el-button>
          <el-button text @click="downloadPage(item)" style="color: #00afff;">下载</el-button>
        </el-col>
      </el-row>
      <el-form :model="formData" v-if="componentParam !== 'mes_mold_mm_process_detail'" :disabled="disabled" label-width="150px">
        <el-row style="font-weight:bold;margin:20px 0 20px 13px;"><b>加工排程：</b></el-row>
        <el-row style="text-align: center;height: 30px;line-height: 30px;">
          <el-col :span="2" :offset="3" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
            序号
          </el-col>
          <el-col :span="3" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
            工序
          </el-col>
          <el-col :span="9" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
            加工内容
          </el-col>
          <el-col :span="4" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
            预估工时(分钟)
          </el-col>
        </el-row>
        <el-row v-for="(item,index) in this.processingSchedulingList" :key="item.nanoid"
                style="text-align: center;margin-top: 10px;align-items: center;">
          <el-col :span="3">
            <el-button v-if="index > 0" circle type="danger" @click="removeOneScheduling(item.nanoid)">
              <el-icon :size="20">
                <Close/>
              </el-icon>
            </el-button>
          </el-col>
          <el-col :span="2" style="text-align: center;">
            {{ index + 1 }}
          </el-col>
          <el-col :span="3">
            <el-select v-model="item.working_procedure" @change="getWorkingProcedure(item.working_procedure)"
                       filterable clearable @clear="getWorkingProcedure(item.working_procedure)" placeholder="工序">
              <el-option v-for="item1 in this.workingProcedureList" :value="item1.value" :key="item1.value"
                         :label="item1.label"></el-option>
            </el-select>
          </el-col>
          <el-col :span="9">
            <el-input v-model="item.details" autosize type="textarea"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input-number style="width: 100%" controls-position="right" v-model="item.estimated_duration">
            </el-input-number>
          </el-col>
          <el-col :span="1">
            <el-button v-if="index > 0" type="primary" circle @click="removeLastScheduling(index)">
              <el-icon>
                <Top/>
              </el-icon>
            </el-button>
          </el-col>
          <el-col :span="1">
            <el-button v-if="index < this.processingSchedulingList.length-1 " type="primary" circle
                       @click="removeNextScheduling(index)">
              <el-icon>
                <Bottom/>
              </el-icon>
            </el-button>
          </el-col>
        </el-row>
        <el-row style="text-align: center;margin-top: 10px">
          <el-col :span="3">
            <el-button type="primary" circle @click="addOneScheduling()">
              <el-icon :size="20">
                <Plus/>
              </el-icon>
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="justify-content: center;width: 90%;margin-top: 10px">
        <el-button type="primary" v-if="componentParam === 'mes_mold_processing_scheduling_add'" @click="createScheduling">
          保存
        </el-button>
        <el-button type="primary" v-if="componentParam === 'mes_mold_processing_scheduling_update'" @click="updateScheduling">
          保存
        </el-button>
      </el-row>

      <div v-if="componentParam === 'mes_mold_mm_process_detail'">
        <el-row style="font-weight:bold;margin-top: 20px;margin-left: 13px;"><b>日志记录：</b></el-row>
        <frame-query
            ref="frameQuery"
            componentParam="mes_mold_mm_process_detail"
            :parent-data="queryParam"
        ></frame-query>
      </div>
    </div>


    <!--    打印-->
    <div v-if="componentParam === 'mes_mold_processing_scheduling_print'">
      <div id="button-page" style="font-size: 20px;width: 100%;height: 100%">
        <el-form :model="formData" :disabled="disabled" label-width="200px" class="custom_label">
          <el-row justify="space-evenly" style="font-size: 30px"><b>模具编号：{{ formData.mold_id }}</b>
            <b>零件编号：{{ formData.part_no }}</b></el-row>
          <el-row style="margin:0 0 10px 13px;"><b>零件信息：</b></el-row>
          <el-row style="text-align: center;">
            <el-col :span="10">
              <el-form-item label="模具编号：">{{ formData.mold_id }}</el-form-item>
              <el-form-item label="零件编号：">{{ formData.part_no }}</el-form-item>
              <el-form-item label="成本类型：">{{ formData.cost_type_name }}</el-form-item>
              <el-form-item label="零件名称：">{{ formData.part_name }}</el-form-item>
              <el-form-item label="数量：">{{ formData.number }}</el-form-item>
              <el-form-item label="材质：">{{ formData.material }}</el-form-item>
              <el-form-item label="规格：">{{ formData.specifications }}</el-form-item>
              <el-form-item label="热处理硬度：">{{ formData.heat_treatment_hardness }}</el-form-item>
              <el-form-item label="备注：">{{ formData.remark }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="零件二维码：">
              </el-form-item>
              <el-image style="width: 50%;height: 80%" :src="url" fit="contain">
                <template #error>
                  <div class="image-slot">
                    {{ "加载失败" }}
                  </div>
                </template>
              </el-image>
            </el-col>
          </el-row>

          <el-row style="margin:0 0 10px 13px;"><b>加工排程：</b></el-row>
          <el-row
              style="text-align: center;height: 30px;line-height: 30px;font-weight: bold;">
            <el-col :span="2" style="border:groove 1px #e0dddd;">序号</el-col>
            <el-col :span="3" style="border:groove 1px #e0dddd;">工序</el-col>
            <el-col :span="14" style="border:groove 1px #e0dddd;">加工内容</el-col>
            <el-col :span="5" style="border:groove 1px #e0dddd;">预估工时(分钟)</el-col>
          </el-row>
          <el-row v-for="item in this.processingSchedulingList" :key="item.nanoid"
                  style="text-align: center;margin-top: 10px;align-items: center;">
            <el-col :span="2" style="border:groove 1px #e0dddd;">
              {{ item.order_no }}
            </el-col>
            <el-col :span="3" style="border:groove 1px #e0dddd;">
              {{ item.working_procedure_name }}
            </el-col>
            <el-col :span="14" style="text-align: left;border:groove 1px #e0dddd;">
              {{ item.details }}
            </el-col>
            <el-col :span="5" style="border:groove 1px #e0dddd;">
              {{ item.estimated_duration }}
            </el-col>

          </el-row>

        </el-form>
      </div>
      <el-row justify="center" style="width: 95%;margin: 20px 0 0 0">
        <el-button type="primary" @click="printScheduling">打印</el-button>
      </el-row>

    </div>
  </div>

</template>

<script>

import {Bottom, Close, Plus, Top} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";
import html2canvas from "html2canvas";

export default {
  name: "ProcessingSchedulingAdd",
  components: {Bottom, Top, Plus, Close},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formData: {},
      processingSchedulingList: [],
      moldIdList: [],
      partNoList: [],
      fileList: [],
      workingProcedureList: [],
      disabled: false,
      printDisable: false,
      url: '',
      urlId:'',
      urlFileList: [],

    };
  },
  computed: {
    costTypeList() {
      return this.$store.getters['core/getDictList']('mes_mold_cost_type');
    },

    queryParam() {
      return {
        scheduling_id: this.formData.id
      }
    },
  },
  created() {
    this.getMoldList();
    this.getWorkingProcedureList();
    if (this.componentParam !== 'mes_mold_processing_scheduling_add') {
      this.formData = this.parentData;
      this.getProcessingSchedulingList();
      this.getQrImageById()
      if (this.formData.attachments) {
        this.getAttachments();
      }
    } else {
      this.addFiveScheduling();
    }
    if (this.componentParam === 'mes_mold_processing_scheduling_details' || this.componentParam === 'mes_mold_mm_process_detail'
        || this.componentParam === 'mes_mold_processing_scheduling_print') {
      this.disabled = true
      if (this.componentParam === 'mes_mold_processing_scheduling_print') {
        this.printDisable = true
      }
    }
  },
  mounted() {
  },

  methods: {
    async getProcessingSchedulingList() {
      this.processingSchedulingList = await this.$http('mesMoldMmDsService.getProcessingSchedulingList', this.parentData)
    },
    //根据二维码图片id获取二维码
    async getQrImageById() {
      let qrImgeFile = await this.$http('mesMoldMmDsService.getFileById', {file_id: this.parentData.qr_file_id})
      this.url = qrImgeFile.url;
    },
    //获取二维码
    async getQrImage() {
      this.formData = await this.$http('mesMoldMmDsService.getUrl', this.formData)
      this.urlFileList = this.formData.qr_file
    },
    //获取文件
    async getAttachments() {
      this.formData = await this.$http('mesMoldMmDsService.getAttachments', this.formData)
      if (this.formData.attachmentsList) {
        this.fileList = this.formData.attachmentsList
      }
    },
    //更新排程
    async updateScheduling() {
      if (!this.formData.mold_id) {
        this.$message.error("请选择模具编号！")
        return
      }
      if (!this.formData.part_no) {
        this.$message.error("请选择零件编号！")
        return
      }
      if (!this.formData.cost_type) {
        this.$message.error("请选择成本类型！")
        return
      }
      if (!this.processingSchedulingList) {
        this.$message.error("请填写加工排程！")
        return
      }
      for (let i = 0; i < this.processingSchedulingList.length; i++) {
        let index = i + 1;
        if (!this.processingSchedulingList[i].working_procedure) {
          this.$message.error("序号" + index + "请选择工序！")
          return
        }
        if (!this.processingSchedulingList[i].details) {
          this.$message.error("序号" + index + "请填写加工内容！")
          return
        }
        if (!this.processingSchedulingList[i].estimated_duration) {
          this.$message.error("序号" + index + "请填写预估工时！")
          return
        }
      }

      this.formData.processingSchedulingList = this.processingSchedulingList
      await this.$http('mesMoldMmCreateService.updateScheduling', this.formData)
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },

    //校验工序在同一个排程中不能重复选择
    getWorkingProcedure(working_procedure) {
      if (!working_procedure){
        return
      }
      let i = 0;
      this.processingSchedulingList.forEach(processingScheduling => {
        if (processingScheduling.working_procedure === working_procedure) {
          i++
        }
      })
      if (i>1){
        this.$message.error("工序不能重复选择")
      }

    },

    //创建排程
    async createScheduling() {
      if (!this.formData.mold_id) {
        this.$message.error("请选择模具编号！")
        return
      }
      if (!this.formData.part_no) {
        this.$message.error("请选择零件编号！")
        return
      }
      if (!this.formData.cost_type) {
        this.$message.error("请选择成本类型！")
        return
      }
      if (!this.processingSchedulingList) {
        this.$message.error("请填写加工排程！")
        return
      }
      // let objList = [];
      for (let i = 0; i < this.processingSchedulingList.length; i++) {
        let index = i + 1;
        let obj = this.processingSchedulingList[i];

        if (!(!obj.working_procedure && !obj.details && !obj.estimated_duration)) {
          if (!obj.working_procedure) {
            this.$message.error("序号" + index + "请选择工序！")
            return
          }
          if (!obj.details) {
            this.$message.error("序号" + index + "请填写加工内容！")
            return
          }
          if (!obj.estimated_duration) {
            this.$message.error("序号" + index + "请填写预估工时！")
            return
          }
        }
        // if (obj.working_procedure &&  obj.details && obj.estimated_duration){
        //   objList.push(obj)
        // }
      }
      this.processingSchedulingList = this.processingSchedulingList.filter(item => item.working_procedure ||
          item.details || item.estimated_duration);
      if (this.processingSchedulingList.length === 0){
        this.$message.error("加工排程不能为空！")
        return
      }
      this.formData.qr_file_id = this.urlId
      this.formData.processingSchedulingList = this.processingSchedulingList
      await this.$http('mesMoldMmCreateService.createScheduling', this.formData)
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async createQrCode() {
      if (this.formData.mold_id && this.formData.part_no && this.formData.cost_type) {
        this.formData.part_qr_code = this.formData.mold_id + '-' + this.formData.part_no + this.formData.cost_type.substring(0, 1)
        let file = await this.$http('mesMoldMmDsService.createQrCode', {part_qr_code: this.formData.part_qr_code})
        this.url = file.url;
        this.urlId = file.id;
      } else {
        this.url = "";
        this.urlId = "";
      }
    },
    async getPartInfo() {
      if (!this.formData.part_no || !this.formData.mold_id) {
        await this.createQrCode();
        return
      }
      let partInfo = await this.$http('mesMoldMmDsService.getPartInfo', {
        part_no: this.formData.part_no,
        mold_id: this.formData.mold_id
      })
      this.formData.part_name = partInfo.part_name
      this.formData.number = partInfo.number
      this.formData.material = partInfo.material
      this.formData.specifications = partInfo.specifications
      this.formData.heat_treatment_hardness = partInfo.heat_treatment_hardness
      this.formData.remark = partInfo.remark
      await this.createQrCode();
    },
    async moldIdChange(mold_id) {
      this.partNoList = []
      this.formData = {
        id:this.formData.id
      }
      if (!mold_id) {
        await this.createQrCode();
        return
      }
      this.partNoList = await this.$http('mesMoldDsService.getBomByMoldId', {mold_id: mold_id})
      this.formData.mold_id = mold_id
    },
    async getMoldList() {
      this.moldIdList = await this.$http('mesMoldDsService.getMoldAll')
    },

    async getWorkingProcedureList() {
      this.workingProcedureList = await this.$http('mesMoldMmDsService.getAllWorkingProcedure')
    },

    async addFiveScheduling() {
      let i = 0;
      while (i < 5) {
        this.addOneScheduling();
        i++;
      }
    },

    //向上移动
    removeLastScheduling(index) {
      for (let i = 0; i < this.processingSchedulingList.length; i++) {
        if (index === i && i > 0) {
          let tmp = this.processingSchedulingList[i]
          this.processingSchedulingList[i] = this.processingSchedulingList[i - 1]
          this.processingSchedulingList[i - 1] = tmp
        }
      }
    },

    //向下移动
    removeNextScheduling(index) {
      for (let i = 0; i < this.processingSchedulingList.length; i++) {
        if (index === i) {
          let tmp = this.processingSchedulingList[i]
          this.processingSchedulingList[i] = this.processingSchedulingList[i + 1]
          this.processingSchedulingList[i + 1] = tmp
        }
      }
    },

    //添加加工排程
    addOneScheduling() {
      this.processingSchedulingList.push({
        nanoid: nanoid(),
      })
    },

    //删除加工排程
    removeOneScheduling(nanoid) {
      let index = this.processingSchedulingList.findIndex(item => item.nanoid === nanoid);
      if (index > 0) {
        this.processingSchedulingList.splice(index, 1);
      }
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        // this.formData.attachments = []
        return
      }

      this.formData.attachments = ids;
    },

    startPage(item, itemData) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "mes/PrcPdf";
      windowObj.name = item.originalName;
      windowObj.parentData = {sys_file: item, itemData: itemData};
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1350 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    //下载文件
    downloadPage(item) {
      let url = item?.url;
      if (!url) {
        return
      }
      let name = item.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },

    //打印详情
    async printScheduling() {
      const element = document.getElementById('button-page');
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL('image/png');

      const printWindow = window.open('打印预览', '_blank', 'height=600,width=900');
      printWindow.document.write(`<img src="${imgData}" style="width: 100%; height: auto;" />`);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 10);

    },

  },
}
</script>

<style lang="less" scoped>

:deep(.el-form-item) {
  --font-size: 20px;
  margin-bottom: 15px;
}

.custom_label :deep(.el-form-item__label) {
  font-size: 20px; /* 更改字体大小 */
  font-weight: bold; /* 更改字体粗细 */
}

.graph_container {
  background-color: white;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 20px;
}

.startPageClass {
  color: #00afff;
  margin-left: 30px;
  width: 400px;
  justify-content: left
}

</style>